module.exports = __webpack_public_path__ + "img/1448731342.52db3ca1.jpg";